import { inject, Pipe, PipeTransform } from '@angular/core';
import { DatepickerService } from '@shared/services/datepicker.service';

@Pipe({
 name: 'getEcolodgeDateInfo',
 pure: true,
 standalone: true,
})
export class GetEcolodgeDateInfoPipe implements PipeTransform {
 datepickerService = inject(DatepickerService);
 transform(value: unknown, ...args: unknown[]): any {
  return (this.datepickerService.ecolodgeCalenderDetails() as any).get(value);
 }
}
